var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.99935C7.5 10.5519 7.28051 11.0818 6.88981 11.4725C6.49911 11.8632 5.9692 12.0827 5.41667 12.0827C4.86413 12.0827 4.33423 11.8632 3.94353 11.4725C3.55283 11.0818 3.33334 10.5519 3.33334 9.99935C3.33334 9.44681 3.55283 8.91691 3.94353 8.52621C4.33423 8.13551 4.86413 7.91602 5.41667 7.91602C5.9692 7.91602 6.49911 8.13551 6.88981 8.52621C7.28051 8.91691 7.5 9.44681 7.5 9.99935Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.41602L7.5 8.33268M11.6667 14.5827L7.5 11.666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15.4167C15.8333 15.9692 15.6138 16.4991 15.2231 16.8898C14.8324 17.2805 14.3025 17.5 13.75 17.5C13.1975 17.5 12.6676 17.2805 12.2769 16.8898C11.8862 16.4991 11.6667 15.9692 11.6667 15.4167C11.6667 14.8641 11.8862 14.3342 12.2769 13.9435C12.6676 13.5528 13.1975 13.3333 13.75 13.3333C14.3025 13.3333 14.8324 13.5528 15.2231 13.9435C15.6138 14.3342 15.8333 14.8641 15.8333 15.4167ZM15.8333 4.58333C15.8333 5.13587 15.6138 5.66577 15.2231 6.05647C14.8324 6.44717 14.3025 6.66667 13.75 6.66667C13.1975 6.66667 12.6676 6.44717 12.2769 6.05647C11.8862 5.66577 11.6667 5.13587 11.6667 4.58333C11.6667 4.0308 11.8862 3.50089 12.2769 3.11019C12.6676 2.71949 13.1975 2.5 13.75 2.5C14.3025 2.5 14.8324 2.71949 15.2231 3.11019C15.6138 3.50089 15.8333 4.0308 15.8333 4.58333Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEventIcon);
export default __webpack_public_path__ + "static/media/share-event-icon.0fc1896b79a22c357e30b16027a08a9b.svg";
export { ForwardRef as ReactComponent };